import React, { useState } from 'react'
import { useEffect } from 'react'
import { connectStore } from 'redux-box';
import { module as schoolGuidedPath } from "@st/schoolGuidedPath";
import { module as ui } from 'store/ui'
import { module as activity } from 'store/activity'

import Select from 'react-select'
import './gpUnits_sync.css'
import { ThemeButton } from '../../../static/styled/custom.styled';

let platformsList = [
    {
        label: 'CMS',
        value: 'CMS'
    },
    // {
    //     label: 'CBSE',
    //     value: 'CBSE'
    // },
    {
        label: 'Hello',
        value: 'Hello'
    },
]
const customStyles = {
    menu: (provided, state) => ({
        ...provided,
        position: "absolute",
    }),
    control: (provide) => ({
        ...provide,
        width: "95%",
        margin: "0 auto",
        border: "none",
        boxShadow: "none",
    }),
};

const GPUnitsSyncModal = ({ schoolGuidedPath, ui, activity }) => {

    const [platforms, setPlatforms] = useState([])
    const [selectedUnits, setSelectedUnits] = useState(schoolGuidedPath.sync_units_list.map((str) => str.id))

    const handleCardClicked = (unit) => {
        if (selectedUnits.includes(unit.id)) {
            setSelectedUnits(prev => prev.filter((data) => data !== unit.id))
        } else {
            setSelectedUnits(prev => [...prev, unit.id])
        }
    }

    const handleSyncNow = () => {
        let payload = {
            platforms: platforms.map((plt) => plt.value),
            unit_ids: selectedUnits
        }
        schoolGuidedPath.syncUnitsToOtherPlatforms(payload)
        ui.hideModal()
    }

    const isChecked = (id) => selectedUnits.some((item) => item === id);
    // console.log(selectedUnits)
    return (
        <div className='stories_sync_modal'>
            <p className='stories_sync_modal_header'>Sync units to other platforms</p>
            <div className="table-container">
                <table className="info-table">
                    <thead>
                        <tr className='stories_sync_table_header_row'>
                            <th>Action</th>
                            <th>Name</th>
                            <th>Grade</th>
                            <th>Description</th>
                            {/* <th>Content Type</th> */}
                        </tr>
                    </thead>
                    <tbody>
                        {schoolGuidedPath.sync_units_list && schoolGuidedPath.sync_units_list.length > 0 ?
                            schoolGuidedPath.sync_units_list.map((unit, index) => {
                                return (
                                    <tr key={unit.id}>
                                        <td>
                                            <input type="checkbox" checked={isChecked(unit.id)}
                                                onChange={() => handleCardClicked(unit)} />
                                        </td>
                                        <td>{unit.name}</td>
                                        <td>{activity.grades && activity.grades.length > 0 && activity.grades.find((grd) => grd.id === unit.grade).name}</td>
                                        <td>{unit.short_description}</td>
                                        {/* <td>{schoolGuidedPath.section_data && schoolGuidedPath.section_data.length > 0 && schoolGuidedPath.section_data[0].content_type}</td> */}
                                    </tr>
                                )
                            })
                            :
                            <tr> No units added for sync.</tr>
                        }
                    </tbody>
                </table>
            </div>

            <div className="platforms_list_container">
                <p className="platforms_list_title">
                    Select Platforms
                </p>

                <Select
                    className="dropdown-container stories_sync_platform_select"
                    value={platforms}
                    onChange={(selectedSection) =>
                        setPlatforms(selectedSection)
                    }
                    options={platformsList}
                    placeholder="Select Platforms"
                    styles={customStyles}
                    menuPlacement="auto" // auto, top, or bottom
                    menuPosition="fixed"
                    isMulti={true}
                />
            </div>

            <ThemeButton primary onClick={handleSyncNow}>
                Sync Now
            </ThemeButton>
        </div>
    )
}

export default connectStore({
    schoolGuidedPath, ui, activity
})(GPUnitsSyncModal)